
import CSearchList from '@/components/c-search-list'
import CTable from '@/components/c-table'
import AddDialog from './components/add-dialog.vue'
import EditDialog from './components/edit-dialog.vue'
import {
  getIndexConfig,
  getTableConfig,
  moduleType,
  state
} from './config'
import { defineComponent, reactive, toRefs, onMounted } from 'vue'
import { usePagination } from '@/hooks/usePagination'
import { btnName } from '@/utils'
import { getList } from './api'

export default defineComponent({
  name: 'enterprise-api-setting-query',
  components: { CSearchList, CTable, AddDialog, EditDialog },
  setup() {
    const data = reactive({
      ...getIndexConfig(),
      addVisible: false,
      editVisible: false,
      editRow: {} as any
    })

    const tableConfig = reactive(getTableConfig())

    /**
     * @description: 列表接口
     * @return {void}
     */
    const getListFn = () => {
      const params = {
        currPage: tableConfig.pagination.currentPage,
        pageSize: tableConfig.pagination.pageSize,
        ...data.queryForm
      }
      tableConfig.loading = true
      getList(params)
        .then((res: any) => {
          const list = (res.data.list || []).map((item: any) => {
            item.statusText = state[item.status] || '-'
            return item
          })
          tableConfig.data = list
          tableConfig.pagination.total = res.data.total || 0
        })
        .finally(() => {
          tableConfig.loading = false
        })
    }

    const { pageCurrentChange, pageSizeChange } = usePagination(
      tableConfig.pagination,
      () => {
        getListFn()
      }
    )

    /**
     * @description: 查询事件
     * @param {*} params
     * @return {void}
     */
    const handleSearch = (params: object) => {
      data.queryForm = params
      getListFn()
    }

    /**
     * @description: 重置事件
     * @param {*} params
     * @return {void}
     */
    const handleReset = (params: object) => {
      data.queryForm = params
    }

    /**
     * @description: 创建
     * @return {void}
     */
    const handleAdd = (): void => {
      data.addVisible = true
    }

    /**
     * @description: 弹窗提交后刷新列表（回到第一页）
     * @return {void}
     */
    const handleRefreshList = (): void => {
      tableConfig.pagination.currentPage = 1
      getListFn()
    }

    /**
     * @description: 编辑
     * @param {*} row
     * @return {void}
     */
    const handleEdit = (row: any): void => {
      data.editRow = { ...row }
      data.editVisible = true
    }

    /**
     * @description: 将数字列表拼接成字典对应的字符串
     * @param {Array} list
     * @param {Object} map
     * @return {string}
     */
    const formatList = (list: number[] | undefined, map: Record<number, string>): string => {
      if (!Array.isArray(list) || !list.length) return ''
      return list.map(item => map[item] || item).join('、')
    }

    onMounted(() => {
      getListFn()
    })

    return {
      ...toRefs(data),
      btnName,
      tableConfig,
      handleSearch,
      handleReset,
      handleAdd,
      handleEdit,
      handleRefreshList,
      pageCurrentChange,
      pageSizeChange,
      moduleType,
      state,
      formatList
    }
  }
})
